import { AppContextEnum } from "@/lib/enum/appContext.enum";
import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import { ThgHttpClientProvider } from "@/services/thg/thg-http-client.provider";
import { CallSessionService } from "../mrfiktiv/v1/CallSessionService";
import { MrfiktivRealtimeSessionControllerFindAllParamsGen } from "../mrfiktiv/v1/data-contracts";
import { ConfigModule } from "@/store/modules/config";

/**
 * Communicate with Call Session API, switching based on app context.
 */
export class CallService {
  mrfiktivProxy: CallSessionService;
  thgProxy: CallSessionService;

  /**
   * Construct the service.
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider, thgHttpClientProvider: ThgHttpClientProvider) {
    this.mrfiktivProxy = new CallSessionService(mrfiktivHttpClientProvider.client());
    this.thgProxy = new CallSessionService(thgHttpClientProvider.client());
  }

  /**
   * Returns the proxy for the current app context.
   */
  get proxy(): CallSessionService {
    if (ConfigModule.appContext === AppContextEnum.THG_PORTAL || ConfigModule.appContext === AppContextEnum.THG) {
      return this.thgProxy;
    }

    return this.mrfiktivProxy;
  }

  /**
   * Get all call sessions for a partner.
   */
  async getAll(query: MrfiktivRealtimeSessionControllerFindAllParamsGen) {
    return (await this.proxy.realtimeSessionControllerFindAll(query)).data;
  }

  /**
   * Get one call session by id.
   */
  async getOne(partnerId: string, sessionId: string) {
    return (await this.proxy.realtimeSessionControllerFindOne(partnerId, sessionId)).data;
  }
}

/**
 * Communicate with Call Session API, switching based on app context.
 */
export default new CallService(new MrfiktivHttpClientProvider(), new ThgHttpClientProvider());
